import styled from '@emotion/styled';
import { typography } from 'src/theme/typography';
import { media } from 'src/theme/breakpoints';
const NavbarQuoteDetailStyle = styled('div')`
    .card {
        background-color: var(--white);
        flex-shrink: 0;
        border: 1px solid var(--sand-400);
        border-radius: 6px;
        padding: 1rem;
        margin-bottom: 1rem;
    }

    .box-consultant {
        ${typography.bodyXs}
        color: var(--sand-700);

        .consultant {
            width: 60%;
        }

        p {
            margin-bottom: 5px;
        }
        .golfer {
            ${typography.bodyL}
            margin-top: 16px;
        }
        .job {
            ${typography.caption}
        }
        .email {
            ${typography.linkXl}
            color: var(--orange-300);
        }
        .box-right {
            ${typography.bodyXs}
            color: var(--sand-700);
            text-align: right;
            margin-top: 5px;
        }
    }

    .btn-pay {
        background-color: var(--orange-300) !important;
        width: 100%;
        height: 56px;
        ${typography.buttonLg}
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 6px;
        color: var(--sand-100);
        margin: 12px 0 4px;
    }

    .btn-secure {
        background-color: var(--orange-300);
        width: 100%;
        min-height: 48px;
        padding: 12px 20px;
        ${typography.buttonLg}
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        border-radius: 8px;
        color: var(--sand-100);
        margin-bottom: 1rem;
        &:hover {
            background-color: var(--orange-400);
            color: var(--sand-100);
        }
    }

    .btnShare {
        width: 100%;
        height: 48px;
        border-radius: 8px;
        margin-bottom: 1rem;
        color: var(--orange-300) !important;
        border-color: var(--orange-300) !important;
        ${typography.bodyXl}
    }

    .mini-basket {
        .reference {
            margin: -1rem -1rem 1rem;
            background: var(--sand-300);
            text-align: center;
            padding: 8px 0;
            border-radius: 6px 6px 0 0;
            ${typography.bodyL}
        }
    }

    .best-price {
        background: var(--sand-300);
        border-color: var(--sand-300);
        color: var(--sand-700);
        ${typography.bodyXs}
        .img {
            min-width: 103px;
        }
        .title {
            font-size: 20px;
            line-height: normal;
            letter-spacing: -0.03em;
            margin-bottom: 12px;
            font-weight: 700;
        }
    }

    .loyalty {
        background: var(--blue-300);
        border-color: var(--blue-300);
        color: var(--white);
        padding: 16px 16px 32px;
        ${typography.bodyXs}
        .loyalty-logo {
            display: block;
            width: 200px;
            max-width: 100%;
            height: auto;
            margin-bottom: 16px;
        }
        .loyalty-content {
            padding: 0 20px;
        }
        .title {
            ${typography.bodyXl}
            margin-bottom: 8px;
        }
        a {
            color: var(--white);
            text-decoration-line: underline;
        }
    }

    .lifetime {
        display: flex;
        flex-direction: column;
        gap: 16px;
        ${typography.bodyMd}
        color: var(--sand-700);

        .header {
            ${typography.bodyL}
        }

        p {
            margin: 0;
        }

        .btn-pay {
            height: auto;
            min-height: 48px;
            padding: 12px 20px;
            margin: 0;
            border-radius: 8px;
            text-align: center;
            ${typography.buttonLg}
            &:hover {
                background-color: var(--orange-400) !important;
                color: var(--sand-100);
            }
            ${media.mobile} {
                min-height: 40px;
                padding: 8px 16px;
                border-radius: 6px;
            }
        }

        .input {
            height: 40px;
            padding: 5px;
            border: 2px solid var(--orange-300);
            font-size: inherit;
            font-weight: 900;
            border-radius: 0;
            &.ant-input-status-error {
                border-color: #ff4d4f;
            }
        }
    }

    @media screen and (min-width: 1200px) {
        .best-price {
            .title {
                max-width: 185px;
            }
        }
    }
`;
export default NavbarQuoteDetailStyle;
